export default __webpack_public_path__ + "static/media/living-room.2af68413.webp";